<nav class="navbar navbar-expand-lg mb-1" style="background: #91bdf8;" id="header-nav" role="navigation">
    <div class="container"><a class="nav-link smooth-scroll" href="#">Resume</a>
        <button class="navbar-toggler" (click)="showHideNavbar()" type="button" data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
            aria-label="Toggle navigation"
            style="background-image: url('/assets/images/bars-solid.svg');background-repeat: no-repeat; background-size: contain; background-position-x: center; position:relative;z-index: 999;"><span
                class="navbar-toggler-icon"></span></button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ms-auto me-2">
                <li class="nav-item"></li>
                <li class="nav-item" style="
          border-top: 1px dashed  #6194d6;
          border-bottom: 1px dashed #6194d6;">
                    <a class="nav-link smooth-scroll" href="#about">About</a>
                </li>
                <!--
                    <li class="nav-item" style="
          border-top: 1px dashed  #6194d6;
          border-bottom: 1px dashed #6194d6;">
                    <a class="nav-link smooth-scroll" href="#services">Services</a>
                </li>-->
                <li class="nav-item" style="
          border-top: 1px dashed  #6194d6;
          border-bottom: 1px dashed #6194d6;">
                    <a class="nav-link smooth-scroll" href="#skills">Skills</a>
                </li>
                <li class="nav-item" style="
          border-top: 1px dashed  #6194d6;
          border-bottom: 1px dashed #6194d6;">
                    <a class="nav-link smooth-scroll" routerLink="portfolio">Portfolio</a>
                </li>
                <li class="nav-item" style="
          border-top: 1px dashed  #6194d6;
          border-bottom: 1px dashed #6194d6;">
                    <a class="nav-link smooth-scroll" href="#experience">Experience</a>
                </li>
                <li class="nav-item" style="
          border-top: 1px dashed  #6194d6;
          border-bottom: 1px dashed #6194d6;">
                    <a class="nav-link smooth-scroll" routerLink="certificates"
                        routerLinkActive="active">Certificates</a>
                </li>
                <li class="nav-item" style="
          border-top: 1px dashed  #6194d6;
          border-bottom: 1px dashed #6194d6;">
                    <a class="nav-link smooth-scroll" href="#contact">Contact</a>
                </li>
            </ul>
        </div>
    </div>
</nav>